import marcaBlancaServices from 'frontend/api/services/marcaBlancaServices'
import { SET_BANNERS, SET_BANNERS_ERROR } from './action-types'
import { safeLocalStorage, useLocalStorage } from 'frontend/helpers/ssr-helper';

export const getBanners =
  ({ id = null, esDefault = true, defaultOnly, showHomeOnly }) =>
  async (dispatch, getState) => {
    const seccionId =
      id === null &&
      getState().applicationState?.templateData?.mainMenu?.length > 0
        ? getState().applicationState.templateData.mainMenu[0].id
        : id
    const empresaId = getState().applicationState.applicationId

    try {
      const response = await marcaBlancaServices.getBanners({
        empresaId,
        seccionId,
        esDefault,
        defaultOnly,
        showHome: showHomeOnly,
      })
      if (response && response.length > 0) {
        safeLocalStorage.setItem('paisId', response[0].categoria?.paisId)
        safeLocalStorage.setItem('banners', JSON.stringify(response))
      }
      return dispatch({
        type: SET_BANNERS,
        payload: response,
      })
    } catch (error) {
      console.error('Banners error', error)
      return dispatch({ type: SET_BANNERS_ERROR })
    }
  }
